import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m12.355 1.232 5.363 4.47a2 2 0 0 1 0 3.072L13.848 12l3.87 3.225a2 2 0 0 1 0 3.073l-5.363 4.47c-.639.532-1.64.063-1.64-.768V14.61L6.64 18.006c-.99.826-2.271-.71-1.28-1.536l5.354-4.478L5.36 7.53c-.991-.826.29-2.362 1.28-1.536l4.074 3.395v-7.39c0-.83 1.002-1.3 1.64-.767m.36 12.427 3.723 3.103-3.724 3.103zm0-3.318V4.135l3.723 3.103z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=ic_bluetooth-vITl0xio.js.map
